import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BusinessPartnerCard from './BusinessPartnerCard';
import BusinessPartnersList from './BusinessPartnersList';

const BusinessPartners = () => {
  const [selectedNeenor, setSelectedNeenor] = useState(false);
  const [companyid, setcompanyid] = useState(null);
  const [editCreate, setEditCreate] = useState();
  const [fromLocation, setFromLocation] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    //check if the url contains an id parameter
    const urlParams = new URLSearchParams(location.search);
    const id = urlParams.get('id');
    const from = urlParams.get('from');
    const companyid = urlParams.get('companyid');
    if (id) {
      setSelectedNeenor(id);
      setcompanyid(companyid);
      // remove the id from the url
      window.history.replaceState({}, document.title, window.location.pathname);
      setFromLocation(from);
    }
  }, [location]);

  const handleBackButton = () => {
    if (fromLocation === 'build' || fromLocation === 'import' || fromLocation === 'fileLoader') {
      navigate('/NewLoadCustomerValidation/' + companyid + '?from=' + fromLocation);
    } else if (fromLocation === 'cm8') {
      navigate('/CM8CustomerValidation/' + companyid);
    } else {
      setSelectedNeenor(false);
    }
  };

  const [neeNors, setNeeNors] = useState([]);

  return (
    <>
      {selectedNeenor === false ? (
        <BusinessPartnersList
          neeNors={neeNors}
          setNeeNor={setSelectedNeenor}
          setNeeNors={setNeeNors}
          setEditCreate={setEditCreate}
          origin="bp"
        />
      ) : (
        <BusinessPartnerCard
          id={selectedNeenor}
          back={() => handleBackButton()}
          editCreate={editCreate}
          setNeeNor={setSelectedNeenor}
        />
      )}
    </>
  );
};

export default BusinessPartners;
